export default "__VITE_ASSET__Bt4hDtg9__"